import createReactClass from 'create-react-class';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { ErrorAction } from '../actions/errorActions';
import { modalErrorStore } from '../stores/modalError';

function getStateFromStores() {
    return {
        showModal: modalErrorStore.showModal(),
        message: modalErrorStore.message()
    }
}

export const ModalError = createReactClass({
    componentDidMount: function () {
        modalErrorStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        modalErrorStore.unsubscribe(this._onChange);
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },


    close() {
        //call action creator to store the comment here...
        ErrorAction.hideModalError();
    },

    cancel() {
        ErrorAction.hideModalError();
    },

    render: function () {

        return (
            <div>
                <Modal bsSize="large" dialogClassName="errorModal" onHide={this.close} show={this.state.showModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>

                    <div className='modal-body'>
                        {this.state.message}
                    </div>
                    <div className='modal-footer'>
                        {/*<Button id="confirmSubmitButton" bsStyle='danger' onClick={onConfirm}>{confirmText}</Button>*/}
                        <Button id="cancelConfirmButton" onClick={this.cancel}>OK</Button>
                    </div>
                </Modal>
            </div>
        );
    },
});
